import { ThemeStyles } from '@honda-canada/design-system-react';
import css from '@styled-system/css';
const themeStyles = new ThemeStyles();
themeStyles.addBaseStyles('MainContainer')(() => css({
    py: ['m', 'm', 'l'],
}));
themeStyles.addBaseStyles('AccessoryCardContainer')(({ isProtection }) => css({
    display: 'flex',
    flexWrap: 'wrap',
    gap: isProtection ? 'zero' : ['xs', 'xs', 'm'],
    mt: 'm',
}));
themeStyles.addBaseStyles('BackCta')(({ backCtaColor }) => css({
    color: backCtaColor,
    border: 'none',
    lineHeight: '22px',
    mb: ['m', 'm', '17px'],
    '&:hover, &:focus': {
        border: 'none',
    },
}));
themeStyles.addBaseStyles('BackIcon')(() => css({
    mr: '5px',
}));
themeStyles.addBaseStyles('HeaderContainer')(() => css({
    display: 'flex',
    justifyContent: 'space-between',
}));
export default themeStyles;
